import { render, staticRenderFns } from "./GestionBodega.vue?vue&type=template&id=a0c8029e&scoped=true"
import script from "./GestionBodega.vue?vue&type=script&lang=js"
export * from "./GestionBodega.vue?vue&type=script&lang=js"
import style0 from "./GestionBodega.vue?vue&type=style&index=0&id=a0c8029e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c8029e",
  null
  
)

export default component.exports